<div class="p-dynamic-dialog-body">
    <div>
        <label class="text-style">{{errorMessage}}</label>
    </div>
    <app-dop-table [tableMeta]="tableMeta" [columnsMeta]="errorGridColumnMeta" [gridData]="finalGridData"
        [totalRecords]="totalRecords" (filterChangeEvent)="receiveFilterChange($event)">
    </app-dop-table>
</div>
<div class="p-dynamic-dialog-footer">
    <div class="flex-body">
        <div class="align-right">
            <button *ngIf="displayOkButton" pButton type="submit" label="Ok" class="m-r-12"
                (click)="onOkButtonClick()"></button>
            <button pButton type="submit" label="Cancel" class="m-r-12" (click)="onCancelButtonClick()"></button>
        </div>
    </div>
</div>